<template>
  <div>
    <div class="my-8">
      <figure class="figure-one">
        <i
          v-if="!imageData"
          class="fas fa-images"
          placeholder="Select Image"
          @click="pickFile"
        ></i>
      </figure>
      <div>
        <input
          ref="image"
          type="file"
          style="display: none"
          accept="image/*"
          @change="onFilePicked"
        >
      </div>
    </div>
  </div>
</template>


<script>

export default {
  name: 'UploadImg',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      imageData: null,
      file: {},
    };
  },
  methods: {
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      // Get file
      const { files } = e.target;
      // If file is available
      if (files[0] !== undefined) {
        // Convert file into base64
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.imageData = fr.result;
        });
      }
    },
  },
  watch: {
    imageData(val) {
      this.$emit('input', val);
    },
    value: {
      handler(val) {
        if (!val) {
          this.imageData = null;
          this.$refs.image.value = null;
        } else {
          this.imageData = val;
        }
      },
    },
  },
};
</script>


<style scoped>
.figure-one {
  font-size: 14px;
  cursor: pointer;
  margin: 0;
}
figure:hover {
  color: rgb(5, 144, 144);
  transition: 0.4s;
}
</style>
